export type ExtractLayerCode = 'G' | 'S' | 'L' | 'M' | 'W';

export interface ExtractMetadataRequestData {
  creatorDescription: string;
  category: string;
  subcategory: string;
  categoryName: string;
  subcategoryName: string;
}

export const EXTRACT_ENDPOINT_BY_LAYER: Record<ExtractLayerCode, string> = {
  G: '/ai/extract-metadata/song',
  S: '/ai/extract-metadata/star',
  L: '/ai/extract-metadata/look',
  M: '/ai/extract-metadata/move',
  W: '/ai/extract-metadata/world',
};

export const EXTRACT_FILE_FIELD_BY_LAYER: Record<ExtractLayerCode, string> = {
  G: 'audioFile',
  S: 'imageFile',
  L: 'imageFile',
  M: 'videoFile',
  // OpenAPI prose says "file"; schema currently still points to videoFile.
  W: 'file',
};
